// EventList.js

import React from 'react';
import { Link } from 'react-router-dom';
import './EventList.css';
//import contact from '../../assets/events/name.jpg'

export const events = [
    {
        name: "From Zero to Impact: Digital Sustainability Award Winner 2025",
        date: "Sept 5, 2025",
        desc: "Our journey from a bootstrap startup to achieving ₹33.3L ARR per month has been honored with the Digital Sustainability Award (Startup Category) at the 18th Annual Environment & Energy Conclave 2025, New Delhi. This recognition celebrates our commitment to sustainable growth, energy efficiency, and innovation through technology.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQFU6RnQdu1_HA/feedshare-shrink_800/B56ZkwNI3MIAAk-/0/1757450422594?e=1760572800&v=beta&t=oAtq-t7BigDwNa6yy_eHu2gmkjGpA8NjpFiJLwENZo8"
    },
    {
        name: "Looms 3.0 Conclave – Empowering Traditional Industries with AI & Digital Innovation (Guwahati, Aug 26–28, 2025)",
        date: "Aug 26-28, 2025",
        desc: "An enriching 3-day conclave at Vivanta by Taj, Guwahati, themed “Empowering Traditional Industries with AI and Digital Integration.” The event brought together policymakers, industry leaders, and entrepreneurs through workshops, buyer–seller meets, and technical sessions.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQH-RtjV6SvCDA/feedshare-shrink_1280/B56ZkZS8F6G4Aw-/0/1757066020329?e=1760572800&v=beta&t=jeh9oy76SuK5Cw-rocGZklhtYK_S2U2Frxf6v2oLELs"
    },
    {
        name: "Tech-E Summit 2025 – Bridging Bengal’s Innovation with Bengaluru’s Tech Leadership",
        date: "May 8–9, 2025",
        desc: "The Tech-E Summit 2025, hosted by The Bengal Chamber of Commerce and Industry with support from Webel and the Government of West Bengal, created a powerful platform in Bengaluru for emerging startups from Bengal to connect with leading investors, mentors, and industry leaders. With sessions on digital empowerment, successful entrepreneurship journeys, and the city’s global competitiveness, the summit strengthened ties between Bengal’s innovation ecosystem and India’s tech capital.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQH5Y0BEoxsmIw/feedshare-shrink_800/B56Zj0qNbHHMAg-/0/1756451363889?e=1760572800&v=beta&t=zKxHR7tnHTBG_jKg5cgtaK4BuiR3Pk_K_QdHz1hFo9U"
    },
    {
        name: "Blockchain Summit 2025 – Inaugural Ceremony by BFPF in New Delhi",
        date: "April 2, 2025",
        desc: "Blockchain For Productivity Forum (BFPF) proudly hosted the inaugural Blockchain Summit 2025 in New Delhi, bringing together policymakers, industry leaders, and innovators to shape India’s blockchain future. Highlights included the Green Chain Leadership Award for Sustainable Blockchain Innovation, presented to Mr. Arjun Dutta of IQPonics Technologies, and an inspiring keynote by Hon. Dr. Faggan Singh Kulaste, Hon’ble MP and Former Union Minister.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQHEf9apOP5pXw/feedshare-shrink_2048_1536/B56ZgzuE1JG4Aw-/0/1753214410342?e=1760572800&v=beta&t=CDyeIRnsT5VNlhhHysOWvjc5HvCiv1djSDwS6m-1Y5M"
    },
    {
        name: "BITC 2025 – Building a Smart & Sustainable IT Future for Kolkata",
        "date": "March 5, 2025",
        "desc": "At the Bengal Business IT Conclave 2025, leaders from startups, IT, and government discussed how eco-conscious infrastructure, digital connectivity, and resilient ecosystems can position Kolkata as a sustainable innovation hub for the future of work.",
        "img": "https://media.licdn.com/dms/image/v2/D5622AQGgXq8Tq4Em5Q/feedshare-shrink_2048_1536/B56Zfmd4yWGQA0-/0/1751918286207?e=1760572800&v=beta&t=Ug9ZUuVj9R-gRFDo9cHBI3zcc1qvS8Iw7inYH2u8XJs"
    },

    {
        name: "Investor Connect 2025 – Linking Startups with Capital",
        date: "Feb 10, 2025",
        desc: "Investor Connect 2025 was organized to bridge startups with venture capitalists, angel investors, and financial institutions. Startups pitched their ideas, opening pathways for funding and mentorship.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQFyAf78P0CqhQ/feedshare-shrink_1280/B56ZfSFE8HGQAo-/0/1751576237085?e=1760572800&v=beta&t=deIGGPI-9PtFaCvQ0Q7cwmZjSawQBOztgE9I4uXSxsY"
    },
    {
        name: "Memorable Visit to Central Institute of Technology, Kokrajhar",
        date: "Jan 24, 2025",
        desc: "A memorable visit to CIT Kokrajhar with Team Smart Edge, Dolly Bhasin Ma’am & STIHUB CITK.  Engaging discussions on sustainable agri value chains, silk weaving, and eco-conscious production opened doors for collaboration across Northeast India. The journey to Gelephu, Bhutan added valuable insights, making the experience truly rewarding.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQEJT--K_6UbYA/feedshare-shrink_2048_1536/B56ZeqlVPwHQAs-/0/1750913605425?e=1760572800&v=beta&t=EIA1vfFVRPPSettj-UpbRiz6vOKobyzNxi6cYzAXHew"
    },
    {
        name: "Stakeholder Consultation on AI Readiness – Building a Digitally Empowered Assam",
        date: "Jan 17–19, 2025",
        desc: "Hon’ble CM Dr. Himanta Biswa Sarma led the Stakeholder Consultation on AI Readiness (RAM) at AASC, Guwahati, under MeitY’s Safe & Trusted AI Mission with UNESCO & Ikigai Law. The event united policymakers, industry leaders & experts to drive responsible AI, innovation, and digital empowerment—marking Assam’s stride toward global competitiveness.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQHsMXLOXFB9GA/feedshare-shrink_2048_1536/B56Zd_c0xAG0A8-/0/1750189952889?e=1761177600&v=beta&t=KWeWQc-veYwTE-cDmKo_I0fHrlZ3RYsOvkwiqXZzLCo"
    },
    {
        name: "IQVenus Technologies Artisan Showcase – Celebrating Craft, Creativity & Culture",
        date: "2025",
        desc: "IQVenus Technologies, in collaboration with Zuxtra Network, proudly hosted the Artisan Showcase.A vibrant celebration of craftsmanship, creativity, and cultural heritage.From textiles and woodwork to ceramics and sustainable fashion, artisans showcased their finest works.The event honored tradition while embracing innovation through live demos and inspiring discussions.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQF_9o7wXzMtPA/feedshare-shrink_1280/B56ZZW2Y1AGQAk-/0/1745213820984?e=1761177600&v=beta&t=9L7l_eN5Fefzc1D-ZiZq2pTN0z98lbqYUt89s37i2aY"
    },

    {
        name: "Trailblazing Growth: Fundraising & Equity Mastery Workshop",
        date: "Dec 13, 2024",
        desc: "Excited to be part of the Fundraising & Equity Management Workshop for early-stage startups! The session offered powerful insights on attracting investors, managing equity, and scaling with confidence. Grateful to the organizers and participants for creating such an inspiring platform to foster #entrepreneurship, #innovation, and #growth. Together, we’re building a stronger startup ecosystem!",
        img: "https://media.licdn.com/dms/image/v2/D5622AQHrUcjBH7cmoQ/feedshare-shrink_800/B56ZSkLebaGsAg-/0/1737921261731?e=1761177600&v=beta&t=UOga0hdlv27ztybAqGxNZtfr2nVc8V5w9wtAWfGTzbk"
    },
    {
        name: "Innovation Unleashed at the Inaugural NE Tech Summit",
        date: "Dec 9, 2024",
        desc: "STPI in collaboration with NIDC Ltd organized the inaugural NE Tech Summit at RCEMPA, Kohima. The summit brought together industry leaders, startups, and policymakers to ignite innovation and strengthen the startup ecosystem.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQEPWeA126JBdg/feedshare-shrink_1280/B56ZP6sLlzG8Ao-/0/1735077709218?e=1760572800&v=beta&t=6LOYIgtvgyKAizQ3Bk2BYGiklJCTMhyCdSP937qlTe4"
    },
    {
        name: "Bengaluru Tech Summit 2024",
        date: "Dec 2024",
        desc: "Attended Bengaluru Tech Summit at Bengaluru Palace. Co-presented blockchain QR code verification solution with Rahul Singh. Gained insights on AI, biotech, and spacetech.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQGd0UCKkQfhqg/feedshare-shrink_1280/feedshare-shrink_1280/0/1733549871178?e=1760572800&v=beta&t=Ao-Tx3w-r1Gj4Sc6xcuTmDWdPJDbxUqovvHztstu3gE"
    },
    {
        name: "Smart Agri Summit 2024",
        date: "Nov 13, 2024",
        desc: "Presented IQPonics at Smart Agri Summit in Hyderabad. Demonstrated sustainable farming & blockchain-enabled supply chain transparency.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQG3fnNFVDs8lw/feedshare-shrink_1280/feedshare-shrink_1280/0/1732252451653?e=1760572800&v=beta&t=7THN9kLQ0viURNDX4H8G8Cf_lG5Z2neLmq1nrjtp6mU"
    },
    {
        name: "India Blockchain Summit 2024",
        date: "Nov 2024",
        desc: "Attended India Blockchain Summit 2024 in Delhi. Gained insights from leaders on blockchain adoption, Web3 innovation, and digital infrastructure.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQFWeFNIAKIp6A/feedshare-shrink_1280/feedshare-shrink_1280/0/1729931063706?e=1760572800&v=beta&t=aOApcKE6GPYYFI9yBzoNWZi3eAvNz3XUQnpw7mXXJfc"
    },
    {
        name: "India Mobile Congress 2024 - IQMingsen",
        date: "Oct 2024",
        desc: "IQMingsen represented Bengal’s tech capabilities at IMC 2024. Showcased smart training solutions and connected with leaders across industries.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQHLVBIT4n6npQ/feedshare-shrink_1280/feedshare-shrink_1280/0/1729305735375?e=1760572800&v=beta&t=XT7mJ45LfJHYgIw9YG9aZK__aEeOPObx-_7aAOiVrJ0"
    },
    {
        name: "India Mobile Congress 2024 - IQVenus",
        date: "Oct 2024",
        desc: "Exhibited IQVenus Technologies Pvt Ltd among 300 startups at IMC inaugurated by PM Modi. Honored to present IQV Virtual Try-on & supply chain solutions.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQGEMMgSnJy9zA/feedshare-shrink_800/feedshare-shrink_800/0/1729184761603?e=1760572800&v=beta&t=L1cGBG0Y3ICq41SYSF-f_kkU6kktjZAKplGU6oWlvdE"
    },
    {
        name: "Indo-Pacific Economic Conclave 2024",
        date: "Sept 2024",
        desc: "Represented Team IQApex at Indo-Pacific Economic Conclave, Kolkata. Engaged with diplomats, policy makers & trade experts from 11 countries.",
        img: "https://media.licdn.com/dms/image/v2/D4E22AQFibSsXBpNlNQ/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1727725767098?e=1760572800&v=beta&t=PoqGL_YCxGjdjLM_EWop_2oxfHn12UMtP1xcPLajJAk"
    },
    {
        name: "Investor Connect Program - Shillong",
        date: "Aug 2024",
        desc: "Spoke on behalf of Team IQVenus at Investor Connect in Shillong. Inspiring discussions with entrepreneurs, investors & ecosystem leaders.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQEdEMJ3asJY2Q/feedshare-shrink_1280/feedshare-shrink_1280/0/1724653202952?e=1760572800&v=beta&t=gU1KGY1T-Tn_3_GfiLcqSJ4fZNes7xqqft8_MXzyAgs"
    },
    {
        name: "2nd TECH-E SUMMIT - BCC&I",
        date: "Aug 1-2, 2024",
        desc: "Joined TECH-E SUMMIT as delegate. Discussed innovation, sustainability & tech growth with leaders, investors, and mentors.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQGQ9aIoUZizSg/feedshare-shrink_1280/feedshare-shrink_1280/0/1723373990523?e=1760572800&v=beta&t=axyw4uE5gHupccyayvEtDg33atlhXmq7JF0MPg2ZDGw"
    },
    {
        name: "15th Edition Business IT Conclave - BITC 2024",
        date: "May 2024",
        desc: "Attended BITC 2024 by The Bengal Chamber with Oracle, Govt. of WB, academia & industry leaders. Gained insights, shared startup perspectives.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQHe_80823eEPg/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1720002848544?e=1760572800&v=beta&t=cThNwSQ6SCbIEHc_ip4pQ3tfZ-RXBB_zSZUhvoFfjZs"
    },
    {
        name: "Team AGS in Cohort 3 of IDEAS - ISI Kolkata",
        date: "April 2024",
        desc: "Thrilled that Team AGS has been selected for Cohort 3 of IDEAS at ISI Kolkata. Honored to be among the chosen few and excited for this journey.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQEg_e5qZwuj4g/feedshare-shrink_800/feedshare-shrink_800/0/1714070989758?e=1760572800&v=beta&t=SfSbVBqvRNppmGApihJLls8S8jLDzqMP9-9tL0Q0-XU"
    },
    {
        name: "Visit of Shri S. Krishnan at STPI Shillong",
        date: "March 18, 2024",
        desc: "Shri S. Krishnan - Secretary, MeitY, visited STPI Shillong office and interacted with NorthEast CoE Ecosystem partners. A fantastic opportunity for collaboration.",
        img: "https://media.licdn.com/dms/image/v2/D4E22AQG72pyXx2rX5A/feedshare-shrink_1280/feedshare-shrink_1280/0/1710921999652?e=1760572800&v=beta&t=0TnS6Z4ioyf1seFgKCRyg1VGK4cW5BedsSWlHEt1PWc"
    },
    {
        name: "Youth Engagement in Ecological Restoration",
        date: "April 2024",
        desc: "Attended youth-led initiative on ecological restoration with G20 Global Land Initiative & UNCCD. Discussed land restoration & sustainability.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQFWq3phzfEESA/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1710729863784?e=1760572800&v=beta&t=1pVI9Fleum61YXlNozV0PQb_rAgcJVyTwxhfZy933x4"
    },
    {
        name: "Climate Justice & Sustainable Development Dialogue",
        date: "March 2024",
        desc: "Presented sustainable agriculture models at WSF Nepal 2024. Advocated for climate justice & carbon sequestration practices.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQHA6elfT7Wbww/feedshare-shrink_1280/feedshare-shrink_1280/0/1709811104182?e=1760572800&v=beta&t=g59ADcTDSMHRn8o70FqDnVUCvJc0twbbhgm6nczg0mw"
    },
    {
        name: "OCP 4.0 Competition by STPI",
        date: "Dec 2023",
        desc: "Won the OCP 4.0 competition held by STPI Guwahati. Recognized for innovation and contribution towards emerging tech solutions.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQEwhvH14e4nmg/feedshare-shrink_1280/feedshare-shrink_1280/0/1702291800537?e=1760572800&v=beta&t=Ubkw5_snZi4cqGkJWmZ6h7TgFnQGKaUTEot47jHNaak"
    },
    {
        name: "State Science & Technology Congress",
        date: "2020",
        desc: "Selected in top 20 inventors representing West Bengal at the State Science & Technology Congress organized by DST & Biotechnology.",
        img: "https://media.licdn.com/dms/image/v2/C5122AQFoYaeaOUoXpA/feedshare-shrink_800/feedshare-shrink_800/0/1583049197374?e=1760572800&v=beta&t=ixd6xBlQRKyKeRL-tpzgqZMS8mjHnyOz1Bw5L4vruVE"
    },
    {
        name: "Tech Fest Udgam - IIT Guwahati",
        date: "Jan 2024",
        desc: "Attended Udgam Tech Fest at IIT Guwahati. Connected with innovators, angel investors, and students, fostering collaborations and partnerships.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQG-3PnryC5KPA/feedshare-shrink_800/feedshare-shrink_800/0/1705933605410?e=1760572800&v=beta&t=iBG0UmThz5YYbLNpV0RsntLyQ9uNmntsHUT0DS-geHo"
    },
    {
        name: "Bengal Global Business Summit 2023",
        date: "Nov 22, 2023",
        desc: "Engaged with UK delegates on innovation & sustainability. Discussions with USAID and CRB on waste management, agri ecosystems, and SDGs.",
        img: "https://media.licdn.com/dms/image/v2/D5622AQFaF8vflcVuKA/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1700895664369?e=1760572800&v=beta&t=_LVTwlXC-QBpqmk2uflBNy1mBlMJtig_4CpD3zVCg_Y"
    },
    {
        name: "16th Edition Environment & Energy Conclave",
        date: "Sept 2023",
        desc: "Engaging discussions on sustainable energy, innovation, and global collaboration. Connected with leaders from NABCONS and SwitchON Foundation.",
        img: "https://media.licdn.com/dms/image/v2/D4D22AQH_LCTA9op6xA/feedshare-shrink_800/feedshare-shrink_800/0/1693232048492?e=1760572800&v=beta&t=EHZvqdXLA7JCn59nVayeOjHIc8IcBjKyLyqrcWeuuaU"
    },
    {
        name: "Sustainability Development Goals (SDG) Conference",
        date: "May 2023",
        desc: "Participated in SDG conference organized by The Bengal Chamber of Commerce and Industry & CRB. Introduced Greenlife IQPonics as a sustainable farming venture.",
        img: "https://media.licdn.com/dms/image/v2/D4D22AQE7MqV6a7SpUA/feedshare-shrink_800/feedshare-shrink_800/0/1684065563341?e=1760572800&v=beta&t=zx_8odqdsiMYzVuEXE9ewm0h6WpT2kG8o4WwbaPZiQs"
    },
    {
        name: "Bengal Global Business Summit 2022",
        date: "April 20-21, 2022",
        desc: "Enthralled to be a part of the sixth edition of Bengal Global Business Summit. Hon'ble CM Mamata Banerjee greets industry leaders at Biswa Bangla Convention Centre.",
        img: "https://media.licdn.com/dms/image/v2/C4D22AQFgVmVeZj5dZA/feedshare-shrink_1280/feedshare-shrink_1280/0/1651064902939?e=1760572800&v=beta&t=rJP_xggzo5Wy8s4U4oeiEisJzqZv-sqTkMunEHHIJaQ"
    },
    {
        name: "Harvard Project for Asian and International Relations (HPAIR) Conference",
        date: "Jan 2021",
        desc: "Attended HPAIR conference and had the opportunity to meet talented people from around the world. Many delegates applied for Winter Internship in our startups Brickview Studios and IQApexLabs. A great networking experience with long-lasting connections. Grateful to Zeel Patel, Eric Lin, and the entire HPAIR team for their meticulous planning and perfect execution.",
        img: "https://media.licdn.com/dms/image/v2/C4E22AQFimemIMi-rtA/feedshare-shrink_800/feedshare-shrink_800/0/1611050494227?e=1760572800&v=beta&t=9bMWW3r-xyTMbgJ883IwAUqMsvSD5BsRbOuIrEWHwjA"
    },
    {
        name: "West Bengal State Science and Technology Congress (WBSSTC)",
        date: "Feb 2020",
        desc: "Selected as a Fellow Delegate among the top 20 inventors representing West Bengal, India, to showcase two inventions. The event was organized by the Department of Science & Technology and Biotechnology, Government of West Bengal.",
        img: "https://media.licdn.com/dms/image/v2/C5122AQFoYaeaOUoXpA/feedshare-shrink_800/feedshare-shrink_800/0/1583049197374?e=1760572800&v=beta&t=ixd6xBlQRKyKeRL-tpzgqZMS8mjHnyOz1Bw5L4vruVE"
    }






    // Add more events as needed in similar reverse chronological order
];

const EventList = () => {
    return (
        <div className="event-list">
            {events.map((event, index) => (
                <div className="event" key={index}>
                    <div className="event-header">
                        <p style={{ color: "#B6EADA" }}>{event.date}</p>
                        <h2>{event.name}</h2>
                    </div>
                    <img
                        src={event.img}
                        alt={event.name}
                        style={{ width: "100%", borderRadius: "10px" }}
                        onError={(e) => { e.target.src = 'https://via.placeholder.com/400x300?text=Event+Image'; }}
                    />
                    <p className="event-desc">{event.desc}</p>
                    <Link to={`/events/${index}`} className="event-link">View Details</Link>
                </div>
            ))}
        </div>
    );
};

export default EventList;
